import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getPendingInvites } from '../../../reducers/AdminUserMgtReducer';
import CustomTable from '../TableComponents/CustomTable';

const PendingInvites = () => {
  const dispatch = useDispatch();

  const pendingInvites = useSelector((state) => state.actionsReducer.invites);

  useEffect(() => {
    dispatch(getPendingInvites());
  }, []);

  let inviteData = [];
  if (pendingInvites) { inviteData = pendingInvites; }

  const pendingInvitesColumns = [
    { id: 'name', label: 'Name' },
    { id: 'organization', label: 'Organization' },
    { id: 'email', label: 'Email' },
    { id: 'start', label: 'Invite Date' },
    { id: 'expire', label: 'Hours to expiration' },
    { id: 'invite_actions', label: 'Actions' },
  ];
  return (
    <CustomTable
      unique="action_id"
      columns={pendingInvitesColumns}
      tableDetails={inviteData}
    />
  );
};
export default PendingInvites;
